import { HTMLInputTypeAttribute } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import { BsInfoCircleFill } from 'react-icons/bs'
import { BHCheckbox } from '..'
import { useBHToast } from '../../hooks/useBHToast'

interface BHInputProps {
  className?: string
  title?: string
  currentValue: string
  onChange: (newValue: string) => void
  numberOfLines?: number
  disabled?: boolean
}

function BHInput({
  className,
  title,
  currentValue,
  onChange,
  numberOfLines,
  disabled,
}: BHInputProps) {
  // const toast = useBHToast()

  // function showInfo() {
  //   if (fieldDetails.info) {
  //     toast(fieldDetails.info, 'info')
  //   }
  // }

  if (className === undefined) className = '';


  return (
    <div className={`flex flex-col items-left ${className}`}>
      <label className="text-md">
        <span className="flex items-center gap-2">{title && title}</span>
      </label>
      <textarea
        maxLength={200}
        rows={numberOfLines || 1}
        className={`my-1 p-2 ${numberOfLines ? '' : 'resize-none'
          } border border-bh-black`}
        value={currentValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
      {/* {fieldDetails.note && <p className="text-xs">{fieldDetails.note}</p>} */}
    </div>
  )
}

export default BHInput
